import { USER_CONTEXT_TOKEN_KEY } from '@deighton/shared-ui/core';

/** localStorage key holding the region the stored auth state belongs to. */
export const AUTH_REGION_STORAGE_KEY: string = 'dtims_auth_region';

/**
 * Every auth key the shell (and the licensing pages it embeds) writes, in localStorage or
 * sessionStorage. Okta names are the okta-auth-js 8 defaults (lib/constants); the shell's
 * token manager uses its own storage key on top of them.
 */
export const AUTH_STORAGE_KEYS: ReadonlyArray<string> = [
  'okta-token-storage-shell',
  'okta-token-storage-licensing',
  'okta-token-storage',
  'okta-cache-storage',
  'okta-transaction-storage',
  'okta-shared-transaction-storage',
  'okta-original-uri-storage',
  'okta-pkce-storage',
  'okta-idx-response-storage',
  USER_CONTEXT_TOKEN_KEY,
  'dtims_licensing_access_token',
  'dtims_licensing_user_identity',
];

/**
 * Drops auth state that belongs to another region, so a `we` token or issuer is never reused
 * against `ae` (getSavedOktaConfig() reads the stored issuer at startup).
 *
 * ponytail: the ceiling is one region signed in per browser on dtims.app; switching regions
 * signs the user out. The upgrade is region-prefixed storage keys in @deighton/shared-ui.
 * @param regionKey - The region resolved for this page load.
 * @param local - localStorage.
 * @param session - sessionStorage.
 * @returns True when stored auth state was removed.
 */
export function isolateAuthStorage(regionKey: string, local: Storage, session: Storage): boolean {
  if (local.getItem(AUTH_REGION_STORAGE_KEY) === regionKey) {
    return false;
  }
  for (const key of AUTH_STORAGE_KEYS) {
    local.removeItem(key);
    session.removeItem(key);
  }
  local.setItem(AUTH_REGION_STORAGE_KEY, regionKey);
  return true;
}
